import { render, staticRenderFns } from "./sign_up.vue?vue&type=template&id=7170c2f6&lang=pug&"
import script from "./sign_up.vue?vue&type=script&lang=coffee&"
export * from "./sign_up.vue?vue&type=script&lang=coffee&"
import style0 from "./sign_up.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./sign_up.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports